import arms from "./../sounds/arms.ogg";
import bodyWord from "./../sounds/body.ogg";
import ears from "./../sounds/ears.ogg";
import eyes from "./../sounds/eyes.ogg";
import face from "./../sounds/face.ogg";
import feet from "./../sounds/feet.ogg";
import fingers from "./../sounds/fingers.ogg";
import hands from "./../sounds/hands.ogg";
import head from "./../sounds/head.ogg";
import legs from "./../sounds/legs.ogg";
import mouth from "./../sounds/mouth.ogg";
import nose from "./../sounds/nose.ogg";
import hair from "./../sounds/hair.ogg";
import heart from "./../sounds/heart.ogg";
import armsImg from "./../images/arms.png";
import bodyWordImg from "./../images/body.png";
import earsImg from "./../images/ears.png";
import eyesImg from "./../images/eyes.png";
import faceImg from "./../images/face.png";
import feetImg from "./../images/feet.png";
import fingersImg from "./../images/fingers.png";
import handsImg from "./../images/hands.png";
import headImg from "./../images/head.png";
import legsImg from "./../images/legs.png";
import mouthImg from "./../images/mouth.png";
import noseImg from "./../images/nose.png";


export const body = [
    {
      title: "arms",
      polish: "ramiona",
      image:
        armsImg,
        sounds: arms,
    },
    {
      title: "body",
      polish: "ciało",
      image:
        bodyWordImg,
        sounds: bodyWord,
    },
    {
      title: "ears",
      polish: "uszy",
      image:
        earsImg,
        sounds: ears,
    },
    {
      title: "eyes",
      polish: "oczy",
      image:
        eyesImg,
        sounds: eyes,
    },
    {
      title: "face",
      polish: "twarz",
      image:
        faceImg,
        sounds: face,
    },
    {
      title: "feet",
      polish: "stopy",
      image:
        feetImg,
        sounds: feet,
    },
    {
      title: "fingers",
      polish: "palce",
      image:
        fingersImg,
        sounds: fingers,
    },
    {
      title: "hands",
      polish: "ręce",
      image:
        handsImg,
        sounds: hands,
    },
    {
      title: "head",
      polish: "głowa",
      image:
        headImg,
        sounds: head,
    },
    {
        title: "legs",
        polish: "nogi",
        image:
          legsImg,
          sounds: legs,
      },
      {
        title: "mouth",
        polish: "usta",
        image:
          mouthImg,
          sounds: mouth,
      },
      {
        title: "nose",
        polish: "nos",
        image:
          noseImg,
          sounds: nose,
      },
      {
        title: "hair",
        polish: "włosy",
        image:
          "https://images.unsplash.com/photo-1605980766335-d3a41c7332a1?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80",
          sounds: hair,
      },
      {
        title: "heart",
        polish: "serce",
        image:
          "https://images.unsplash.com/photo-1571172964276-91faaa704e1f?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1050&q=80",
          sounds: heart,
      },
  ];
